/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listPlayers = /* GraphQL */ `
  query ListPlayers(
    $filter: ModelPlayerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getPlayer = /* GraphQL */ `
  query GetPlayer($id: ID!) {
    getPlayer(id: $id) {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const playersByStarTotal = /* GraphQL */ `
  query PlayersByStarTotal(
    $purpose: String
    $starTotal: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlayerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    playersByStarTotal(
      purpose: $purpose
      starTotal: $starTotal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listPlayerRestricteds = /* GraphQL */ `
  query ListPlayerRestricteds(
    $filter: ModelPlayerRestrictedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlayerRestricteds(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPlayerRestricted = /* GraphQL */ `
  query GetPlayerRestricted($id: ID!) {
    getPlayerRestricted(id: $id) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const listActivityPeriods = /* GraphQL */ `
  query ListActivityPeriods(
    $filter: ModelActivityPeriodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityPeriods(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getActivityPeriod = /* GraphQL */ `
  query GetActivityPeriod($id: ID!) {
    getActivityPeriod(id: $id) {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const activityPeriodByPlayer = /* GraphQL */ `
  query ActivityPeriodByPlayer(
    $owner: ID
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityPeriodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityPeriodByPlayer(
      owner: $owner
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listRides = /* GraphQL */ `
  query ListRides(
    $filter: ModelRideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRides(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getRide = /* GraphQL */ `
  query GetRide($id: ID!) {
    getRide(id: $id) {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const ridesByPlayer = /* GraphQL */ `
  query RidesByPlayer(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ridesByPlayer(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listQuestEfforts = /* GraphQL */ `
  query ListQuestEfforts(
    $filter: ModelQuestEffortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestEfforts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getQuestEffort = /* GraphQL */ `
  query GetQuestEffort($id: ID!) {
    getQuestEffort(id: $id) {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const effortsForPlayerByCreated = /* GraphQL */ `
  query EffortsForPlayerByCreated(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestEffortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    effortsForPlayerByCreated(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const effortsForRideByCreated = /* GraphQL */ `
  query EffortsForRideByCreated(
    $rideId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestEffortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    effortsForRideByCreated(
      rideId: $rideId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const effortsForPlayerByQuestScore = /* GraphQL */ `
  query EffortsForPlayerByQuestScore(
    $owner: ID
    $questIdScore: ModelQuestEffortByPlayerThenQuestScoreCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestEffortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    effortsForPlayerByQuestScore(
      owner: $owner
      questIdScore: $questIdScore
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getQuestRank = /* GraphQL */ `
  query GetQuestRank($owner: ID!, $questId: ID!) {
    getQuestRank(owner: $owner, questId: $questId) {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const listQuestRanks = /* GraphQL */ `
  query ListQuestRanks(
    $owner: ID
    $questId: ModelIDKeyConditionInput
    $filter: ModelQuestRankFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listQuestRanks(
      owner: $owner
      questId: $questId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        score
        starRating
        owner
        questId
        rideId
        effortId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        effort {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const ranksForPlayerByCreated = /* GraphQL */ `
  query RanksForPlayerByCreated(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestRankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ranksForPlayerByCreated(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        score
        starRating
        owner
        questId
        rideId
        effortId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        effort {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const ranksForRideByCreated = /* GraphQL */ `
  query RanksForRideByCreated(
    $rideId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestRankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ranksForRideByCreated(
      rideId: $rideId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        score
        starRating
        owner
        questId
        rideId
        effortId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        effort {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const ranksForQuestByScore = /* GraphQL */ `
  query RanksForQuestByScore(
    $questId: ID
    $score: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestRankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ranksForQuestByScore(
      questId: $questId
      score: $score
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        score
        starRating
        owner
        questId
        rideId
        effortId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        effort {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listWorlds = /* GraphQL */ `
  query ListWorlds(
    $filter: ModelWorldFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorlds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getWorld = /* GraphQL */ `
  query GetWorld($id: ID!) {
    getWorld(id: $id) {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const worldsByTitle = /* GraphQL */ `
  query WorldsByTitle(
    $title: String
    $sortDirection: ModelSortDirection
    $filter: ModelWorldFilterInput
    $limit: Int
    $nextToken: String
  ) {
    worldsByTitle(
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getQuest = /* GraphQL */ `
  query GetQuest($id: ID!) {
    getQuest(id: $id) {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const listQuests = /* GraphQL */ `
  query ListQuests(
    $filter: ModelQuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
